import React from 'react';
import MailboxPage, { groupByConversation } from '../mailbox/MailboxPage';
import { createMailboxApi } from '../mailbox/api';
import { useAuth } from '../contexts/AuthContext';
import serviceInboxMailboxPlugin from './ServiceInboxMailbox';

/**
 * The service inbox's Mailbox page: the generic mailbox (`src/mailbox/`, over
 * service-inbox's `mailbox_core` routes) with the service inbox's plugin
 * (`ServiceInboxMailbox.js`). Reusable for another client by passing its own
 * API base and plugin.
 */

const api = createMailboxApi('/api/inbox/mailbox');

// Changing mail (read state, flags, moves, writing and sending) needs the `service_inbox_mail` feature on
// top of `service_inbox`; admins hold every feature. Without it the Mailbox is
// view-only: opening a message does not mark it read, and there are no read,
// Archive or Move controls. Tasks and bookings are unaffected. The service
// enforces the same with a 403. Activity (who did what) is not shown in the
// message view (2026-09-30); the changes are still recorded.
const Mailbox = () => {
  const { hasFeature } = useAuth();
  const manage = hasFeature('service_inbox_mail');
  return (
    <MailboxPage
      api={api}
      plugin={serviceInboxMailboxPlugin}
      readState={manage}
      moves={manage}
      compose={manage}
      flags={manage}
    />
  );
};

export { groupByConversation };
export default Mailbox;
